import React, { Component } from 'react';
import '../../css/App.css';
import { observer } from 'mobx-react';
import RadiosGroup from './RadiosGroup'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

const styles = {   
  card:{
    marginTop: "15px",    
  }
}

const txtUseSelections = [
    {value:"AD81783EE3644B6586DB916E76665292", label:"不限制用途"},
    {value:"FB847A9CB5A0482AA2C7EB816993D3F0", label:"醫學研究發展"},
    {value:"25BEEC9DE9FD43BFBD4B324E85CD25A6", label:"社服急難救助"},
    {value:"BBEB05425092406EA9F0070CD172C462", label:"醫院整體維運"},
    {value:"E26EEB0B639A4C2ABEE283DD57BCDB90", label:"員工教育訓練"}
    
    // {value:"A98C9B97693A404C919099C4B2F1957F", label:"教學研究大樓募款"},
    //{value:"FB903705405F4959A1F6C04485A6B146", label:"備註-多項指定用途"}
]

class CardDonateUse extends Component {
  render() {
    const { classes } = this.props;

    return (     
        <Card
        className={classes.card}
        >
          <RadiosGroup
          title = "捐款用途*"
          objectKey = "txtUse"
          selections = {txtUseSelections}
          />
        </Card>        
    );
  }
}

export default withStyles(styles)(observer(CardDonateUse));
